/**
 * Тип карточки
 */
export type CardType = 'CTA' | 'default';

/**
 * Базовый интерфейс для карточки с типом
 */
export interface BaseCardWithType {
  type?: CardType;
}

/**
 * CTA карточка
 */
export interface CTACard extends BaseCardWithType {
  type: 'CTA';
}

/**
 * Обычная карточка
 */
export interface DefaultCard extends BaseCardWithType {
  type: 'default';
}

/**
 * Type guard для проверки CTA карточки
 */
export const isCtaCard = <T extends BaseCardWithType>(
  card: T,
): card is T & CTACard => {
  return card.type === 'CTA';
};
